import styled from "styled-components";
export const PassedActivitiesStyle = styled.div``;
